export const CACHE_BLOG_PAGE = 'CACHE_BLOG_PAGE'
export const CACHE_BLOG_SEARCH_QUERY = 'CACHE_SEARCH_QUERY'
// For the future
export const CACHE_BLOG_CATEGORY = 'CACHE_BLOG_CATEGORY'

const intialState = {
  blog: {
    pages: {},
    categories: {},
    search: {}
  }
}

export default function cache (state = intialState, action) {
  switch (action.type) {
    case CACHE_BLOG_PAGE:
      const pages = {
        ...state.blog.pages,
        [action.page]: action.ids
      }
      return {
        ...state,
        blog: {
          ...state.blog,
          pages
        }
      }
    case CACHE_BLOG_SEARCH_QUERY:
      const search = {
        ...state.blog.search,
        [action.query]: action.ids
      }
      return {
        ...state,
        blog: {
          ...state.blog,
          search
        }
      }
    default:
      return state
  }
}

export function cacheBlogPage (page, ids) {
  return {
    type: CACHE_BLOG_PAGE,
    page,
    ids
  }
}

export function cacheBlogSearchQuery (query, ids) {
  return {
    type: CACHE_BLOG_SEARCH_QUERY,
    query,
    ids
  }
}
